/**
 * Class for making elements sticky on the page so that they are always visible 
 * but fall back into their natural position once they are within the viewport
 */

var Sticky = {};

/**
 * Set an element to be sticky
 * @param {Node} el An element, typically given by getElementById method
 * @param {string} stickyClassName the css class to append when element is out of sight
 * @param {int} minHeight the minimum height of the browser window before we allow sticky to occur (might not want sticky on small sceens)
 */
Sticky.setSticky = function (el, stickyClassName, minHeight) {

	//The sticky marker marks the spot where the element is before being position fixed
	//We continously measure if this marker is within viewport or not, and set the 
	//element to sticky or not based on that
	$(el).before('<div id="stickyMarker" style="height: 1px;"></div>');

	var stickyMarker = document.getElementById('stickyMarker');

	//This is called whenever something changes, like user scrolling the page
	function onVisibilityChange(el, callback) {
	    var old_visible;
	    return function () {
	        var visible = Sticky._isElementVisible(el);
	        if (visible != old_visible) {
	            old_visible = visible;
	            if (typeof callback == 'function') {
	                callback(visible);
	            }
	        }
	    }
	}

	//This is called if the visible has changed compared to what it used to be
	//This adds the sticky class and removes the sticky class on changes in visibility
	var handler = onVisibilityChange(stickyMarker, function(visible) {
		if (!visible && !el.classList.contains(stickyClassName) && window.innerHeight > minHeight)  {
			Sticky._addPlaceHolderElement(el);
			el.classList.add(stickyClassName);
		} else {
			Sticky._removePlaceHolderElement();
			el.classList.remove(stickyClassName);
		}
	});

	//Listen on changes
	$(window).on('DOMContentLoaded load resize scroll', handler); 
}

Sticky._addPlaceHolderElement = function (el) {
	var style = window.getComputedStyle(el, null);	
	$(el).before('<div class="stickyPlaceHolder" style="width: ' + style.getPropertyValue("width") + '; height: ' + style.getPropertyValue('height') + '"></div>');
}

Sticky._removePlaceHolderElement = function () {
	$(".stickyPlaceHolder").remove();
}

Sticky._isElementVisible = function (el) {
    var rect     = el.getBoundingClientRect(),
        vWidth   = window.innerWidth || document.documentElement.clientWidth,
        vHeight  = window.innerHeight || document.documentElement.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) };     

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 
            || rect.left > vWidth || rect.top > vHeight)
        return false;

    // Return true if any of its four corners are visible
    return (
          el.contains(efp(rect.left,  rect.top))
      ||  el.contains(efp(rect.right, rect.top))
      ||  el.contains(efp(rect.right, rect.bottom))
      ||  el.contains(efp(rect.left,  rect.bottom))
    );
}
export default Sticky;